import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ pollResponse }) => {
  const mergedResponses = new Map();

  pollResponse?.forEach((item) => {
    if (
      item.poll_option_id &&
      (!item.archived || (item.archived && item.response_count > 0))
    ) {
      if (mergedResponses.has(item.poll_option_id)) {
        mergedResponses.get(item.poll_option_id).response_count +=
          item.response_count || 0;
      } else {
        mergedResponses.set(item.poll_option_id, { ...item });
      }
    }
  });

  const filteredPollResponse = Array.from(mergedResponses.values());

  const responseCounts = filteredPollResponse?.map((item) =>
    item?.total_response ? item?.total_response : item?.response_count
  );

  const totalResponses = responseCounts?.reduce((sum, count) => sum + count, 0);

  const percentages = responseCounts?.map((count) =>
    ((count / totalResponses) * 100).toFixed(1)
  );

  const labels = filteredPollResponse?.map(
    (item, index) =>
      `${item?.option_text} (${item?.response_count}) - ${
        Math.round(percentages?.[index]) ?? 0
      }%`
  );

  const colors = ["#9151FF", "#EAB308"];

  const data = {
    labels,
    datasets: [
      {
        data: percentages,
        backgroundColor: colors.slice(0, labels.length),
        borderColor: "#fff",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        align: "start",
        labels: {
          boxWidth: 40,
          boxHeight: 40,
          padding: 15,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}%`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: "400px", height: "400px", margin: "0 auto" }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart;
